// src/utils/firestoreHelpers.ts

import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "./firebase";    // Import your Firestore instance
import type { User } from "firebase/auth";

/**
 * Ensure a Firestore user document exists and is up-to-date.
 * Creates if not present, updates if any fields have changed.
 * @param user Firebase Auth User object
 */
export async function ensureUserDoc(user: User) {
  const userRef = doc(db, "users", user.uid);
  const snap = await getDoc(userRef);

  // Build user data from Auth
  const userData = {
    fullName: user.displayName || "",
    email: user.email || "",
    mobile: user.phoneNumber || "",
    profileImage: user.photoURL || "",
    // Add timestamps as needed
  };

  if (!snap.exists()) {
    // Create doc for first-time user
    await setDoc(userRef, { ...userData, createdAt: new Date() });
  } else {
    // Update fields if they changed
    await setDoc(userRef, { ...userData, updatedAt: new Date() }, { merge: true });
  }
}
